import { useEffect } from 'react';
import network from '../../lib/AdminNetwork'
import { useLocation,useNavigate} from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import config from '../../lib/config'
import { addTokenCall, customtokenfetch, getCurrency } from '../../actions/users';
import Web3 from 'web3'
import { toast } from 'react-toastify';
import tradeabi from '../../ABI/TRADE.json'
import { Form } from 'react-bootstrap';
import Layout from '../../Layout/Layout';
import Market from '../../ABI/market.json'
export function AddToken()  {
    const navigate = useNavigate();
    var location = useLocation();
    
    var pathname = location.pathname;
    var path = pathname.split("/")[1]

    const [owner_Get, set_Owner_Get] = useState("");
   

    const GetContractServiceFee = async () => {
        
        if (Wallet_Details?.networkConfiguration?.TradeContract) {
          try {
            var web3 = new Web3(Wallet_Details.networkConfiguration.BNBPROVIDER);
            var Contract = new web3.eth.Contract(
              Market,
              Wallet_Details.networkConfiguration.TradeContract
            );
            
            var ownerGet = await Contract.methods.owner().call();
            var ownget = String(ownerGet).toLowerCase();
            
            set_Owner_Get(ownget);
          } catch (err) {
            console.error("GetContractServiceFee_error", err);
          }
        }
      };
  
  const initData = {
    "name":"",
    "address":"",
    "decimal":"",
    "ChainId" : location.state.chain
  }
  
  const Wallet_Details = useSelector((state) => state.wallet_connect_context);
  const [formData,setFormData] = useState(initData) 
  
  
  const {
    name,
    address,
    decimal
  } = formData
  
  useEffect(()=>{
    chainIdCheck()
    GetContractServiceFee()
  },[location])
  

  
  const chainIdCheck = async () => {
    // Check if MetaMask is installed
    // MetaMask injects the global API into window.ethereum
    const hexString = location.state.chain.toString(16);
    
    if (window.ethereum) {
      try {
        // check if the chain to connect to is installed
  
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: location.state.chain == "BNB" ?  config.bnbver : config.ethver }], // chainId must be in hexadecimal numbers
        });
        return true;
      } catch (error) {
        // This error code indicates that the chain has not been added to MetaMask
        // if it is not, then install it into the user MetaMask
        if (error.code === 4902) {
          try {
            await window.ethereum.request({
              method: 'wallet_addEthereumChain',
              params: [
                {
                  chainId: "0x" + hexString,
                  rpcUrl: config.BNBProvider,
                },
              ],
            });
            return true;
          } catch (addError) {
            console.error(addError);
          }
        }
        console.error(error);
      }
    } else {
      // if no window.ethereum then MetaMask is not installed
      //console('MetaMask is not installed. Please consider installing it: https://metamask.io/download.html');
      return false;
  
    }
  }
  
  const handleChange =async(e)=>{
    var address=e.target.value
    const { id, value } = e.target;
    if(value.length >40){
      let formdata = { ...formData, ...{ [id]: value } }
      setFormData(formdata)
    if(e.target.id=="address"){
      
      var resp=await customtokenfetch({contractaddress:address , network : location.state.chain})
      
      if(resp.msg=="Token Fetched operation failed"){
        toast.error("Address Invalid")
        }
        else{
          let formdata = { ...formData, ...{ 'name' :  resp.data.name ,'decimal' : resp.data.decimal , "address" : address  } }
          setFormData(formdata)
        }
    }
    }else{
      let formdata = { ...formData, ...{ [id]: value } }
      setFormData(formdata)
    }
  }
  
  const get_receipt = async (HashValue,web3) => {
    var receipt = await web3.eth.getTransactionReceipt(HashValue);
    
    if (receipt) {
        return receipt
    }
    else {
        get_receipt(HashValue)
    }
  }
  const handleSubmit = async()=>{
    try{
    
    if(Wallet_Details?.UserAccountAddr != ""){
      
      if(Wallet_Details.UserAccountAddr == owner_Get){
  
        var errors = {};
      
        if(!formData.name){
          errors.name = "Token name empty"
          return toast.error("Token name cannot be empty/Invalid Token Address")}
      
        if(!formData.address){
          errors.description = "Token address empty"
          return toast.error("Token address cannot be empty")}
      
          if(Object.keys(errors).length == 0){

          let isExist = await getCurrency(formData)
          
         if(isExist.status){
          return toast.error(isExist?.msg)
         }

        var web3 = new Web3(
            Wallet_Details.providerss
          )
        var contract =  new web3.eth.Contract(
            tradeabi,
              location.state.chain == network.BSC.Chainid ? network.BSC?.TradeContract : network.ETH?.TradeContract )
        
        var hash= await contract.methods.addTokenType([formData.name.toUpperCase()],[formData.address]).send({from : Wallet_Details.UserAccountAddr})
        
        // var receipt = await get_receipt(hash,web3)
        if(hash.status ){
          formData.action = "add"
          var resp = await addTokenCall(formData);
         if(resp?.status){
           toast.success(resp.msg)
           setTimeout(function(){ 
            navigate('/currency')
           }, 2000);
           
         } 
         else if(resp.msg == "Token Already Exists/Token invalid'" ){
           toast.error(resp.msg)
         }
         else{
           toast.error(resp.msg)
         }
        }
          
          
      
        }
      }
      else{
        toast.warning("Admin can only Add Token")
      }
    }else{
      toast.warning("Please Connect Wallet")
    }
  }
  catch(err){
    toast.warning(err.toString())
  }
  
  
  }
  
  
      return (
        <Layout>
        <div>
          <div className="page-header">
          <button className='btn sitebtn mb-4' type='button' onClick={()=> navigate('/currency')} >Back</button>
            <h3 className="page-title"> ADD TOKEN </h3>
           
          </div>
          <div className="row">
           
            <div className="col-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
              
                  <form className="forms-sample">
                    <Form.Group className='mb-3'>
                       <Form.Label>Token Name</Form.Label>
                      <Form.Control type="text" className="form-control" id="name" disabled={true} value={formData.name} placeholder="Name" onChange={(e)=>handleChange(e)} />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                       <Form.Label>Token Address</Form.Label>
                      <Form.Control type="text" className="form-control" id="address" value={formData.address} placeholder="address" onChange={(e)=>handleChange(e)}/>
                    </Form.Group>
                    <Form.Group className='mb-3'>
                       <Form.Label>Token Decimal</Form.Label>
                      <Form.Control type="text" className="form-control" id="decimal" disabled={true} value={formData.decimal} placeholder="Decimal" onChange={(e)=>handleChange(e)}/>
                    </Form.Group>
                  
                    
                   
                    {/* <button type="submit" className="btn btn-primary mr-2" onClick={()=>handleSubmit()}>Submit</button> */}
                  </form>
                <button className='btn sitebtn mb-3 mt-3' type='button' onClick={()=>handleSubmit()}>Submit</button>
  
                </div>
              </div>
            </div>
           
          </div>
        </div>
        </Layout>
      )
    
  }
  
  export default AddToken